export default __webpack_public_path__ + "static/media/Kuthcheman Great Hammer.ed0a2624.jpg";